import Decisions from "../order-sim/Decisions"
import { oiaEngine } from "./engine"

/** /oia-sim/:threadId: the shared decisions page with the OIA's stages and rows. */
export default function OiaDecisions() {
  return <Decisions engine={oiaEngine} />
}
